exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sk-dialog__footer[data-v-4db6eeae] {\n}\n.wrap-item[data-v-4db6eeae] {\n  align-items: center;\n  background: #ffffff;\n  border-radius: 14px;\n}\n.card-title[data-v-4db6eeae] {\n  margin: 0 0 4px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #1e293b;\n}\n.card-subtitle[data-v-4db6eeae] {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #64748b;\n}\n.ml-2[data-v-4db6eeae] {\n  margin-left: 0.5rem\n}\n\n/* Khoảng cách giữa nút Lưu và nút Menu */\n.flex[data-v-4db6eeae] {\n  display: flex\n}\n.justify-end[data-v-4db6eeae] {\n}\n.items-center[data-v-4db6eeae] {\n  align-items: center\n}\n", ""]);

// exports
